<template>
  <Content class="banknew">
    <Breadcrumb class="back-button">
      <BreadcrumbItem to="/">
        <Icon type="ios-home-outline" />
        {{ $t("back") }}
      </BreadcrumbItem>
    </Breadcrumb>
    <Card dis-hover class="banknew-card">
      <div class="loading apollo" v-if="$apollo.queries.BankNew.loading">
        <Spin fix>
          <Icon type="ios-loading" size="18" class="icon-load"></Icon>
          <div>{{ $t("loading") }}</div>
        </Spin>
      </div>

      <!-- Error -->
      <div v-else-if="error" class="error apollo">{{ $t("error") }}</div>

      <!-- Result -->
      <div v-else-if="bankNew" class="result apollo" :gutter="15">
        <div
          :style="{ backgroundImage: `url(${bankNew.image != null ? bankNew.image.url : ''})` }"
          class="image"
          :alt="_i18n.locale === 'en' ? bankNew.title : bankNew.title_al"
        />
        <h1 class="title">{{ _i18n.locale === "en" ? bankNew.title : bankNew.title_al }}</h1>
        <Card dis-hover style="margin-top: 20px">
          <div class="public-DraftEditor-content" v-html="previewText" />
        </Card>
        <Button
          icon="logo-facebook"
          :to="`${bankNew.facebook_link}`"
          target="_blank"
          class="link-to-fb"
          name="Facebook post"
          v-if="bankNew.facebook_link"
        />
        <Button
          icon="logo-twitter"
          :to="`${bankNew.twitter_link}`"
          target="_blank"
          name="Twitter post"
          class="link-to-fb"
          v-if="bankNew.twitter_link"
        />
      </div>
      <!-- No result -->
      <div v-else class="no-result apollo">{{ $t("no_result") }}</div>
    </Card>
  </Content>
</template>
<script>
import marked from 'marked';
import BankNew from '../graphql/New.gql';

export default {
  props: ['id'],
  data() {
    return {
      bankNew: null,
      error: null,
    };
  },
  computed: {
    previewText() {
      const renderer = new marked.Renderer();
      marked.setOptions({
        renderer,
        breaks: true,
        headerIds: false,
        gfm: true,
        tables: true,
        pedantic: false,
        sanitize: true,
        smartLists: true,
        smartypants: false,
      });
      if (!this.bankNew) {
        return marked('');
      }
      return marked(this._i18n.locale === 'en' ? this.bankNew.description : this.bankNew.description_al);
    },
  },
  // methods
  apollo: {
    BankNew: {
      query: BankNew,
      variables() {
        return { id: this.id };
      },
      result({
        data: {
          banknew: { data },
        },
        error,
      }) {
        const img = data.attributes.image && data.attributes.image.data && data.attributes.image.data.attributes;

        this.bankNew = {
          ...data,
          ...data.attributes,
          image: { url: img && img.url ? `${process.env.VUE_APP_STRAPI}${img.url}` : null },
        };

        this.erorr = error;
      },
      update({ banknew }) {
        return banknew;
      },
    },
  },
};
</script>

<style lang="scss">
.back-button {
  margin: 20px 0px;
  padding: 10px;
  background-color: white;
  border-radius: 4px;
}
.banknew {
  margin-bottom: 20px;
  .loading.apollo {
    height: 100%;
  }
  .banknew-card {
    min-height: 500px;
  }
  .result {
    .title {
      margin-top: 20px;
      line-height: 1;
    }
    .image {
      min-height: 500px;
      background-position: center center;
      background-repeat: no-repeat;
      background-size: contain;
      border-radius: 4px;
      background-color: #10a995;
    }
    .link-to-fb {
      margin: 10px 10px 10px 0;
    }
  }
  .demo-spin-col {
    height: 100%;
    border: unset;
  }
  .public-DraftEditor-content {
    font-size: 14px;
    color: #515a6e;
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-weight: bold;
      margin: 1em 0;
      color: #17233d;
    }

    hr {
      height: 0.05em;
      border: 0;
      color: #cccccc;
      background-color: #cccccc;
    }

    blockquote {
      margin: 1em 0;
      border-left: 4px solid #ddd;
      padding: 0 1em;
      color: #666;
    }

    pre {
      font-size: 14px;
      padding: 16px;
      overflow: auto;
      line-height: 1.45;
      background-color: #f6f8fa;
      border-radius: 3px;
    }
    code {
      padding: 0.2em 0.4em;
      margin: 0;
      font-size: 85%;
      background-color: rgba(27, 31, 35, 0.05);
      border-radius: 3px;
      font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
    }

    pre > code {
      border: 0;
      margin: 0;
      padding: 0;
      background-color: #f6f8fa;
      font-size: 100%;
    }

    a,
    a:visited {
      background-color: inherit;
      text-decoration: none;
    }

    img {
      max-width: 100%;
    }

    p,
    div {
      line-height: 1.7em;
    }

    ul,
    ol {
      padding-left: 2em;
    }

    table {
      display: block;
      width: 100%;
      overflow: hidden;
      border-spacing: 0;
      border-collapse: collapse;

      tr {
        background-color: #fff;
        border-top: 1px solid #c6cbd1;
        &:nth-child(2n) {
          background-color: #f6f8fa;
        }
      }

      th,
      td {
        padding: 6px 13px;
        border: 1px solid #dfe2e5;
      }
      th {
        font-weight: 600;
      }
    }

    p,
    blockquote,
    ul,
    ol,
    dl,
    table,
    pre {
      margin-top: 0;
      margin-bottom: 0.72em;
    }
  }
}
</style>
